import { render, staticRenderFns } from "./calyrafit-footer.vue?vue&type=template&id=23d65f04&scoped=true&"
import script from "./calyrafit-footer.vue?vue&type=script&lang=js&"
export * from "./calyrafit-footer.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-footer.vue?vue&type=style&index=0&id=23d65f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d65f04",
  null
  
)

export default component.exports